import { createReducer, on } from '@ngrx/store';
import { EventFilter, IEvent } from 'src/app/core/models/event';
import { resetAppState } from '../global/global.actions';
import { EventActions } from './event.actions';

export interface EventState {
  events: IEvent[];
  selectedEventId: string | null;
  loading: boolean;
  error: unknown | null;
  filters: EventFilter;
}

export const initialEventState: EventState = {
  events: [],
  selectedEventId: null,
  loading: false,
  error: null,
  filters: {
    free: true,
    paid: true,
    studentColours: [],
    schoolIds: [],
  },
};

export const eventReducer = createReducer(
  initialEventState,
  on(EventActions.loadEvents, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(EventActions.loadEventsSuccess, (state, { events }) => ({
    ...state,
    events: events,
    loading: false,
    error: null,
  })),
  on(EventActions.loadEventsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(EventActions.loadFakeEvents, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(EventActions.loadFakeEventsSuccess, (state, { events }) => ({
    ...state,
    events: events,
    loading: false,
    error: null,
  })),
  on(EventActions.loadFakeEventsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(EventActions.updateEvent, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(EventActions.updateEventSuccess, (state, { event }) => ({
    ...state,
    events: state.events.map((e) => (e.id === event.id ? event : e)),
    loading: false,
    error: null,
  })),
  on(EventActions.updateEventFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(EventActions.setFilters, (state, { filters }) => ({
    ...state,
    filters,
  })),
  on(EventActions.resetFilters, (state) => ({
    ...state,
    filters: initialEventState.filters,
  })),
  on(EventActions.selectEvent, (state, { id }) => ({
    ...state,
    selectedEventId: id,
  })),
  on(resetAppState, () => initialEventState),
);
